export default {
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "NotoSansJP", "NotoSans", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
};
